exports.form = require './helpers/form.coffee'
exports.filters = require './helpers/filters.coffee'
exports.masks = require './helpers/masks.coffee'
exports.guid = require './helpers/guid.coffee'

exports.contacts =
  styles: require './helpers/contacts/styles.coffee'
  list_view_modes: require './helpers/contacts/list_view_modes.coffee'
  list_wrapper: require './helpers/contacts/list_wrapper.coffee'

exports.manual_tasks =
  list_wrapper: require './helpers/manual_tasks/list_wrapper.coffee'
  list_item_wrapper: require './helpers/manual_tasks/list_item_wrapper.coffee'

exports.notifications =
  kind_wrapper: require './helpers/notifications/kind_wrapper.coffee'


exports.vue_include = (obj, extensions...) ->
  for extension in extensions
    for property in ['computed', 'methods']
      obj[property] ?= {}
      for sub_property, value of extension[property]
        obj[property][sub_property] ?= value

  obj



// WEBPACK FOOTER //
// ./src/helpers.coffee